import { client, getUrl } from "utils";

export const getBranchesRequest = (filterParams) => client.get(getUrl("branches", filterParams));

export const createBranchRequest = (body) => client.post("branches", body);

export const getBranchByCodeRequest = (code) => client.get(`branch/${code}`);

export const updateBranchRequest = (data) => client.put(`branch/${data.code}`, data);

export const updatePartiallyBranchRequest = (data) => client.patch(`branch/${data.code}`, data);

export const deleteBranchRequest = (code) => client.delete(`branch/${code}`);
